import { render, staticRenderFns } from "./adjustPolicyDialog.vue?vue&type=template&id=5dc89b70&scoped=true&"
import script from "./adjustPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./adjustPolicyDialog.vue?vue&type=script&lang=js&"
import style0 from "./adjustPolicyDialog.vue?vue&type=style&index=0&id=5dc89b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc89b70",
  null
  
)

export default component.exports